export default __webpack_public_path__ + "static/media/headerPopupFNTop.8f9d0e00.png";